
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'PopularTireSizesBlock',

  computed: {
    seasons: function () {
      return (this.values?.seasons || [])
        .map((season) => {
          const slug = season?.title === 'Лето' ? 'leto' : 'zima';
          const sizes = [];
          Object.keys(this.extras?.[slug] || {}).map((key) => {
            sizes.push({
              title: key,
              link: this.extras?.[slug]?.[key],
            });
          });

          return {
            ...season,
            sizes,
          };
        });
    },
  },
});
